type AuthenticationError = {
  wasSessionNotFound: boolean;
  isSessionInvalid: boolean;
  areCredentialsInvalid: boolean;
  hasUnExpectedError: boolean;
  message: string;
};

const authenticationError: AuthenticationError = {
  areCredentialsInvalid: false,
  hasUnExpectedError: false,
  isSessionInvalid: false,
  wasSessionNotFound: false,
  message: "",
};

export type { AuthenticationError };

export { authenticationError };
